import { Link } from "react-router-dom";

import "../../styles/PublishingFooter.css";

export default function PublishingFooter() {
  const currentYear =
    new Date().getFullYear();

  return (
    <footer className="publishingFooter">
      <nav
        className="publishingFooterLinks"
        aria-label="Publishing footer navigation"
      >
        <Link to="/terms">
          Terms of Use
        </Link>

        <Link to="/privacy">
          Privacy Policy
        </Link>

        <Link to="/contact">
          Contact
        </Link>
        <Link to="/collaborate">Collaborate</Link>
      </nav>

      <p className="publishingFooterCopyright">
        &copy; {currentYear} Kenneth L.
        Powell. All rights reserved.
      </p>
    </footer>
  );
}
